// 11. 10. 2026 (owner, BACKLOG #33, docs/crew.md "Chat"): the crew chat's filter for profanity and insults. A word on the
// list is masked (its first letter stays: "f***"), the message goes through. English and Bosnian/Croatian/Serbian (the
// pilot's players); the word is compared after lower case, without diacritics, with common look-alike characters
// (0→o, 1→i, 3→e, 4→a, 5→s, 7→t, @→a, $→s) and with repeated letters collapsed ("fuuuck"). The owner can extend the lists.

/** Whole words only (they are innocent inside longer words: "cockpit", "Dickens"). */
const EXACT = [
  'dick', 'dicks', 'cock', 'cocks', 'pussy', 'fag', 'fags', 'twat', 'wanker', 'bastard', 'prick', 'tits', 'kys',
  'picka', 'picku', 'picke', 'picko', 'pickom', 'pickica', 'kurva', 'kurvo', 'kurve', 'kurvu', 'drolja', 'droljo', 'debil', 'debilu', 'kreten', 'kretenu',
  'balija', 'balijo', 'balije', 'smece', 'peder', 'pederu', 'pedera', 'pederi', 'sranje', 'seronja', 'seronjo',
];

/** The start of a word ("bitches", "retarded", "kurcina"). */
const PREFIX = ['shit', 'bitch', 'asshol', 'whore', 'slut', 'faggot', 'nigg', 'retard', 'cunt', 'motherf', 'govn', 'kurc', 'kurac', 'jebe', 'jebi', 'jeba', 'jebo', 'pizd', 'cetnik', 'ustas', 'sranj', 'seronj', 'pederc'];

/** Anywhere in a word ("motherfucker", "pojebati"). */
const INSIDE = ['fuck', 'jeb'];

const LOOKALIKE: Record<string, string> = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', $: 's', '!': 'i' };
const DIACRITIC: Record<string, string> = { č: 'c', ć: 'c', š: 's', ž: 'z', đ: 'd' };

/** Lower case, without diacritics and look-alikes. */
export function chatNormalize(word: string): string {
  return [...word.toLowerCase()].map((c) => DIACRITIC[c] ?? LOOKALIKE[c] ?? c).join('');
}

/** Repeated letters as one ("fuuuck" → "fuck", "asshole" → "ashole"). */
const collapse = (s: string) => s.replace(/(.)\1+/g, '$1');

const C_EXACT = new Set(EXACT.map(collapse));
const C_PREFIX = PREFIX.map(collapse);
const C_INSIDE = INSIDE.map(collapse);

/** Whether one word is on the list. */
export function chatWordBad(word: string): boolean {
  const n = chatNormalize(word);
  const c = collapse(n);
  if (EXACT.includes(n) || C_EXACT.has(c)) return true;
  if (PREFIX.some((p) => n.startsWith(p)) || C_PREFIX.some((p) => c.startsWith(p))) return true;
  return INSIDE.some((p) => n.includes(p)) || C_INSIDE.some((p) => c.includes(p));
}

/** The message with every listed word masked, and how many were. */
export function filterChat(text: string): { text: string; masked: number } {
  let masked = 0;
  const out = text.replace(/[\p{L}\p{N}@$!]+/gu, (w) => {
    if (!chatWordBad(w)) return w;
    masked++;
    const chars = [...w];
    return chars[0] + '*'.repeat(Math.max(1, chars.length - 1));
  });
  return { text: out, masked };
}
